import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../styles/shared/NavBar.css";

function NavBar() {
    const navigate = useNavigate();
    const location = useLocation();

    // Function to navigate to homepage and scroll to section
    const navigateAndScroll = (section) => {
        if (location.pathname === "/") {
            // If already on the homepage, just scroll smoothly
            document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
        } else {
            // Navigate to homepage and scroll after a slight delay
            navigate("/#" + section);
            setTimeout(() => {
                document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
            }, 500);
        }
    };

    return (
        <div className="navbar-component">
            <div className="navbar">
                <div className="navbar-logo">
                    <img
                        src="/images/Signified-logo-Questrial-Font-1.jpg"
                        alt="Signifide Group International logo"
                    />
                </div>
                <div className="navbar-links-list">
                    <ul className="navbar-links">
                        <li onClick={() => navigate("/")}>Home</li>
                        <li onClick={() => navigate("/kinda-katch")}>Kinda Katch</li>
                        <li onClick={() => navigateAndScroll("about")}>About Us</li>
                        <li onClick={() => navigateAndScroll("products")}>Products</li>
                        <li onClick={() => navigate("/our-team")}>Team</li>
                        <li onClick={() => navigate("/our-partners")}>Partners</li>
                        <li onClick={() => navigate("/contact-location")}>Contact</li>
                    </ul>
                </div>

                {/* Mobile menu */}
                <div className="btn-group">
                    <button
                        type="button"
                        className="btn btn-secondary dropdown-toggle"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        Menu
                    </button>
                    <ul className="dropdown-menu dropdown-menu-end">
                        <li onClick={() => navigate("/")} className="dropdown-item">Home</li>
                        <li onClick={() => navigate("/kinda-katch")} className="dropdown-item">Kinda Katch</li>
                        <li onClick={() => navigateAndScroll("about")} className="dropdown-item">About Us</li>
                        <li onClick={() => navigateAndScroll("products")} className="dropdown-item">Products</li>
                        <li onClick={() => navigate("/our-team")} className="dropdown-item">Team</li>
                        <li onClick={() => navigate("/our-partners")} className="dropdown-item">Partners</li>
                        <li onClick={() => navigate("/contact-location")} className="dropdown-item">Contact</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default NavBar;

